let config = {}
if (process.env.NODE_ENV === 'development') {
  config = {
    email: 'info@b1g1.com',
    server: 'http://127.0.0.1:8000',
    host: 'http://localhost:8080',
    client_id: 1,
    client_secret: 'Fo72n242PouyI7J3HfnR6uMaHcHG124zgvuUQFhX',
    grant_type: 'password',
    membership: 'U2FsdGVkX1+MvpU2TXvCZbBZ8qFvVRQXpT4NxiBFTFfVml70VNFAAFMEMDYwJxiq2gLbY5mDBcB3r779bB61mw==',
    giving: 'U2FsdGVkX1/WmatyuC+KGgfPFqfZwChHd5BqLl37Q6k6a/LEptTvmuAxeuJtsGrcLkUM9XgemSoY+7kzCmL7Hg==',
    // stripe_key: 'pk_live_VTYI35NyQddIPId4iGfUByt5',
    // stripe_key_inc: 'pk_live_4oVpmgsbN1Wbyvz0Jq6n7fjJ00vgBiBbgO',
    payment_server: 'https://payment.b1g1.org',
    hotjar_id: '1947939',
    wcuser_id: 13192,
    environment: 'development',
    purchase_account_amt: 30,
    restricted_countries: [],
    charity_disclosure_countries: ['United States'],
    smallest_package_name: 'Tiny',
    milestone_maximum_contribution_limit: 6,
    restricted_states: []
  }
} else if (process.env.NODE_ENV === 'production') {
  config = {
    email: 'info@b1g1.com',
    // server: 'https://account-api.b1g1.com',
    server: 'https://api.b1g1.com',
    host: 'https://account.b1g1.com',
    client_id: 6,
    client_secret: 'yfKa4pJgdihXhChlSYzKnGG1J7MVy2wqH8fhrX6w',
    grant_type: 'password',
    // stripe_key: 'pk_live_VTYI35NyQddIPId4iGfUByt5',
    // stripe_key_inc: 'pk_live_4oVpmgsbN1Wbyvz0Jq6n7fjJ00vgBiBbgO',
    membership: 'U2FsdGVkX19visCBuqdpxOoAnRmil+5txQglsEYGED+ubgGV1tB67Ro3r7i0/sRUL46TyHMnteZa8ySL1SUHY9FBJUGLxLLn+ACTtHYPnTKVGjXyeQjRusrDjuR6a6epfduHWn1rrbz03ykwOavRphWDDB4dutzkXeHjoTOqHF8=',
    giving: 'U2FsdGVkX18BjMRnoaRxrZwG6W85QIwGwLfT+Ub5T9s17xZMavfGLw0wOu0FfCWBWso51/Ukp21pQlGpx+joaK1Av/KbJ/Glgz1u72aYrIxzqWxHuuDa1twNZc/jI6Hcfnc0N2mE5/Pr+XPXAEkPtYzmwpa5mXwPuKO8tic+QR8=',
    payment_server: 'https://payment.b1g1.org',
    hotjar_id: '1941343',
    wcuser_id: 13217,
    environment: 'production',
    purchase_account_amt: 30,
    restricted_countries: ['United States'],
    charity_disclosure_countries: ['United States'],
    smallest_package_name: 'Tiny',
    milestone_maximum_contribution_limit: 6,
    restricted_states: []
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/app.js